<ng-container>
  <div class="position-relative">
    <input [(ngModel)]="modelDate" [attr.placeholder]="placeholder"  class="form-control form-control-date1 form-control-sm" autocomplete="off" name="date" bsDatepicker #d="bsDatepicker" [bsConfig]="{ dateInputFormat: 'MM/YYYY', minMode: 'month', minDate: minAllowedDate, maxDate: maxAllowedDate }" (ngModelChange)="onSelectedDateChange($event)">
    <button class="btn calendar" type="button" (click)="d.toggle()">
      <img class="img-invert" src="../assets/images/icons/cal-icon.png" alt="" />
    </button>
  </div>
</ng-container>
